export enum AppointmentRequestMessagingStatus {
    OPEN = 'OPEN',
    TRANSFERRED = 'TRANSFERRED',
    CANCELED = 'CANCELED',
    ACCEPTED = 'ACCEPTED'
}
